"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        label: "总装制程",
        discribe: "前往mes cloud查询总装制程",
        url: require("../../assets/img/process1.png"),
    },
    {
        label: "PCBA制程",
        discribe: "正在建设中",
        url: require("../../assets/img/process2.png"),
    },
    {
        label: "充电枪制程",
        discribe: "正在建设中",
        url: require("../../assets/img/process3.png"),
    },
    {
        label: "调试制程",
        discribe: "正在建设中",
        url: require("../../assets/img/process4.png"),
    },
    {
        label: "包装制程",
        discribe: "正在建设中",
        url: require("../../assets/img/process5.png"),
    },
    {
        label: "维修制程",
        discribe: "正在建设中",
        url: require("../../assets/img/process6.png"),
    },
];
